import React from "react";
import "./ProductCategoryHeader.css";
import { FiSearch } from "react-icons/fi";
import { Col, Row } from "react-bootstrap";
import TitleSectionComponent from "../TitleSectionComponent/TitleSectionComponent";
import {LuListVideo} from 'react-icons/lu'
export default function ProductCategoryHeader({
    orderByChangeHandler,
    searchChangeHandler,
}) {
    return (
        <div className="product-category-header">
                <div className="product-category-title-res">
                    <TitleSectionComponent title='تمام دوره ها' icon={<LuListVideo />}/>
                </div>
            <Row className="product-category-wrapper">
                <Col>
                    <div className="product-category-header-right">
                        <select
                            onChange={(e) =>
                                orderByChangeHandler(e.target.value)
                            }
                        >
                            <option value="RegisterDate">
                                مرتب سازی بر اساس تاریخ
                            </option>
                            <option value="Name">مرتب سازی بر اساس نام</option>
                            <option value="Price">
                                مرتب سازی بر اساس قیمت
                            </option>
                            <option value="View">
                                مرتب سازی بر اساس بازدید
                            </option>
                        </select>
                    </div>
                </Col>
                <Col>
                    <div className="product-category-header-left">
                        <div className="product-category-searchbox">
                            <input
                                id="searchInput"
                                type="text"
                                placeholder="آموزش مورد نظر را وارد کنید"
                            />
                            <button
                                onClick={(e) =>
                                    searchChangeHandler(
                                        document.querySelector("#searchInput")
                                            .value
                                    )
                                }
                            >
                                <FiSearch />
                            </button>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    );
}
